import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { MdKeyboardBackspace } from "react-icons/md"
import { JobRequestAction } from "../../../Redux/action/JobRequestAction";
import TableHeader from '../../Common/TableHeader';


const JobRequest = () => {
    const { userResult } = useSelector((state) => state.Auth);
    const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(20);
    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [search, setSearch] = useState("");

    const userInfo = useSelector((state) => state.JobRequest.result);
    const candidateId = userResult?.userid;;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(JobRequestAction(candidateId));
    }, [])

    const handleClick = (e) => {
        setcurrentPage(Number(e.target.id));
    };

    const pages = [];
    for (let i = 1; i <= Math.ceil(userInfo.length / itemsPerPage); i++) {
        pages.push(i);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = userInfo.slice(indexOfFirstItem, indexOfLastItem);
    const newData = userInfo;
    const renderPageNumbers = pages.map((number) => {
        if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
            return (
                <li
                    key={number}
                    id={number}
                    onClick={handleClick}
                    className={currentPage === number ? "active" : null}
                >
                    {number}
                </li>
            );
        } else {
            return null;
        }
    });
    const handleNextbtn = () => {
        setcurrentPage(currentPage + 1);

        if (currentPage + 1 > maxPageNumberLimit) {
            setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
        }
    };

    const handlePrevbtn = () => {
        setcurrentPage(currentPage - 1);

        if ((currentPage - 1) % pageNumberLimit === 0) {
            setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
        }
    };

    let pageIncrementBtn = null;
    if (pages.length > maxPageNumberLimit) {
        pageIncrementBtn = <li onClick={handleNextbtn}> &hellip; </li>;
    }

    let pageDecrementBtn = null;
    if (minPageNumberLimit >= 1) {
        pageDecrementBtn = <li onClick={handlePrevbtn}> &hellip; </li>;
    }

    return (

        <div>
            <div className=""  >
                {/* <div>

                    <div className="jobrequest-secdiv" >
                        <Link to="/candidate_dashboard">
                            <button
                                // onClick={() => navigate(-1)}
                                className="jobrequest-back"
                            >
                                <MdKeyboardBackspace />
                            </button>
                        </Link>
                        <div className='jobrequest-heading'> <h2> Jobs Request </h2></div>
                    </div>
                </div>
                <div className='jobrequest-search'>
                    <div className="form-outline">
                        <input
                            type="search"
                            id="form1"
                            className="form-control-Job"
                            placeholder="Search"
                            aria-label="Search"
                        />
                    </div>
                </div> */}
                <TableHeader isSearch={true} isFilter={false} heading={'Jobs Request'} />
                <div className="">
                    <div className="Job-Request-table-responsive">
                        <table className="table-data">
                            <thead>
                                <tr>
                                    <th scope="col">Candidate Id</th>
                                    <th scope="col">Company Name</th>
                                    <th scope="col">Required Experience</th>
                                    <th scope="col">Designation</th>
                                    <th scope="col">Accepted/Rejected</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems &&
                                    currentItems.map((item, i) => {
                                        return (
                                            <>
                                                <tr key={item.candidateId}>
                                                    <td>#{item.candidateId}</td>
                                                    <td>{item.companyName}</td>
                                                    <td>{item.requiredExperience}</td>
                                                    <td>{item.jobTitle}</td>

                                                    {item.jobAcceptanceStatus === "ACCEPTED" ? (
                                                        <td style={{ color: "green" }}>
                                                            Accepted
                                                        </td>
                                                    ) : item.jobAcceptanceStatus === "REJECTED" ? (
                                                        <td style={{ color: "red" }}>
                                                            Rejected
                                                        </td>
                                                    ) : (
                                                        <td style={{ color: "gray" }}>
                                                            No Action
                                                        </td>
                                                    )}
                                                    <td>
                                                        <Link to={`/job-description/${item.appliedJobsId}`}><button className="accept-reject-button accept-button" >View</button></Link>
                                                    </td>
                                                </tr>
                                            </>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                    {userInfo.length >= 5 ? (
                        <div className="mt-4">
                            <ul className="pageNumbers">
                                <li>
                                    <button
                                        onClick={handlePrevbtn}
                                        disabled={currentPage === pages[0] ? true : false}
                                    >
                                        Prev
                                    </button>
                                </li>
                                {pageDecrementBtn}
                                {renderPageNumbers}
                                {pageIncrementBtn}

                                <li>
                                    <button
                                        onClick={handleNextbtn}
                                        disabled={
                                            currentPage === pages[pages.length - 1] ? true : false
                                        }
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                {/* <div style={{ width: "90%", margin: "0 auto", marginTop: "15px" }} className="grid-container">
                  
                    {userInfo && userInfo.map((item, i) => {
                        return (
                            <>
                                <div key={item.candidateId} style={{ background: "white", boxShadow: "0px 2px 6px gray", borderRadius: "10px" }}>
                                    <div>
                                        <p style={{ fontSize: "21px" }}>{item.companyName}</p>
                                        <p style={{ fontSize: "21px" }}> Experience : <span style={{ color: "gray" }}>{item.requiredExperience}</span></p>
                                        <p style={{ fontSize: "21px" }}>{item.jobTitle}</p>
                                        <div>
                                            <Link to={`/job-description/${item.appliedJobsId}`}><button style={{ padding: "8px 39px", fontSize: "19px", border: "none", color: "white", background: "#417f9c", borderRadius: "4px" }} >View</button></Link>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    })}
                </div> */}
            </div>
        </div>
    )
}


export default JobRequest